import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Tipo from '../../../../components/auth/balanco/listar/form_tipo'


function TipoBalancoScreen() {

    return (
        <Fragment>
            <Head titulo="Alterando Tipo - Módulo de Balanços" />
            <HeaderLogged />
            <Container>
               <Tipo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TipoBalancoScreen;